import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { BASE_URL } from '../constants';

import { Navigation } from "swiper/modules";
import { Button } from "react-bootstrap";

// const reelsData = [
//   { id: 1, video: "/assets/video/reel1.mp4" },
//   { id: 3, video: "/assets/video/reel2.mp4" },
//   { id: 4, video: "/assets/video/reel3.mp4" },
//   { id: 5, video: "/assets/video/reel4.mp4" },
//   { id: 2, video: "/assets/video/reel5.mp4" },
// //   { id: 6, video: "/videos/reel6.mp4" },
// ];

export default function ShopbyReels({allReelsProduct=[]}) {

  
 
  return (
    
    <div className="container py-5">
        <div className="discover-heading">
          <span>Shop by</span>
          <h2>REELS</h2>
        </div>
        <style>
            {
                `
                .reel-card {
  // border-radius: 12px;
  overflow: hidden;
}

.video-wrapper {
  height: 500px;
  overflow: hidden;
  // border-radius: 12px;
}

.video-wrapper video {
  height: 100%;
  object-fit: cover;
}
  .reel-card:hover {
  transform: translateY(-5px);
  transition: 0.3s ease;
}
                `
            }
        </style>
      <Swiper
        modules={[Navigation]}
        navigation
        spaceBetween={20}
        breakpoints={{
          320: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          992: { slidesPerView: 4 }, // 👈 4 per row on laptop
        }}
      >
        {allReelsProduct.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="reel-card text-center">
              
              {/* Reel Video */}
              <div className="video-wrapper">
                <video
                  src={BASE_URL + item.product_video}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-100"
                />
              </div>

              {/* Shop Button */}
              <button className="add-to-cart-btn mt-2">Shop Now</button>
              {/* <Button className="mt-2 w-100">
                Shop Now
              </Button> */}

            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}